import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { SPRAY_EVENT_TYPE_CROP, SPRAY_EVENT_TYPE_WEED } from './constants';
import { SprayEventType } from './types';

const selectSprayEventType = (state: AppState): SprayEventType =>
    state.sprayEventType;

const selectSprayEventTypeIsWeed = createDeepEqualSelector(
    selectSprayEventType,
    (sprayEventType) => sprayEventType === SPRAY_EVENT_TYPE_WEED
);

const selectSprayEventTypeIsCrop = createDeepEqualSelector(
    selectSprayEventType,
    (sprayEventType) => sprayEventType === SPRAY_EVENT_TYPE_CROP
);

export {
    selectSprayEventType,
    selectSprayEventTypeIsWeed,
    selectSprayEventTypeIsCrop
};
